<template>
    <div
        v-if="isShown"
        class="finish"
        :style="style"
        :data-label="label"
    >
    </div>
</template>

<script>
export default {
    name: 'TimelineFinishDesktop',
    props: {
        monthsToShow: {
            type: Number,
            required: true,
        },
        monthsOffset: {
            type: Number,
            required: true,
        },
        flagOffset: {
            type: Number,
            default: null,
        },
        date: {
            type: Object,
            default: null,
        },
    },
    computed: {
        label() {
            return this.date.format('MMMM YYYY');
        },
        style() {
            return {
                left: `${Math.min(100, (this.flagOffset - this.monthsOffset) / this.monthsToShow * 100)}%`,
            };
        },
        isShown() {
            return this.flagOffset > this.monthsOffset;
        },
    },
};
</script>

<style lang="scss" scoped>
    @import '~@/styles/rem';

    .finish {
        height: 384px;
        position: absolute;
        bottom: 0;
        width: 1px;
        pointer-events: none;
        &:after {
            font-size: 12px;
            line-height: 16px;
            text-align: right;
            color: #D1004A;
            content: attr(data-label);
            position: absolute;
            top: -20px;
            width: 100px;
            left: -100px;
            text-transform: lowercase;
        }
        &:before {
            pointer-events: none;
            display: block;
            height: 384px;
            content: " ";
            background-repeat: no-repeat;
            background-position: right bottom;
            background-image: url("../../../../assets/images/account-track/flag.svg");
            min-width: 81px;
            position: absolute;
            left: -81px;
            z-index: 1;
        }
    }
</style>
